"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const Image = ({ src, alt = "", fill, priority, quality, sizes, ...props }) => (
  <img
    src={src}
    alt={alt}
    sizes={sizes}
    loading={priority ? "eager" : "lazy"}
    {...props}
    style={fill ? { ...props.style, position: "absolute", inset: 0, width: "100%", height: "100%" } : props.style}
  />
);
const tourCards = [
    {
        title: "Yala National Park",
        subtitle: "野生動物と大自然の驚異",
        summary: "スリランカで最も高い人気を誇るヤーラ国立公園は、その豊かな生物多様性で世界的に知られています。",
        details: "スリランカで最も高い人気を誇るヤーラ国立公園は、その豊かな生物多様性で世界的に知られています。ワニやゾウ、マングース、そして愛らしいサルたちに加え、世界屈指のヒョウの生息密度を誇ることは、この公園最大の魅力です。砂丘やラグーン、息をのむほど美しい海岸線。さらには長い年月をかけて水が岩を削り出した独特の地形や、多種多様な樹木が織りなす風景は、訪れる人々を圧倒します。観光客のみならず地元の人々をも魅了し続けるこのドラマチックな景観は、一生の記憶に残る体験となるでしょう。",
        duration: "所要時間: 片道 約4時間（1泊2日プランがおすすめ）",
        price: "料金: 195ドル（約25,000 LKR）",
        image: "/images/tours/wildlife-in-yala-national-park_63578.webp",
        alt: "ヤーラ国立公園の野生動物",
        badge: "Safari",
    },
    {
        title: "Vegetable Market",
        subtitle: "ローカル野菜マーケット",
        summary: "地元で採れた色鮮やかなフルーツや野菜、香り高いハーブやスパイスが並ぶ活気ある市場です。",
        details: "地元で採れた色鮮やかなフルーツや野菜、香り高いハーブやスパイス。マーケットを訪れることは、単なる買い物ではなく、この土地の豊かな恵みと人々の温かな暮らしに触れる心躍る体験です。マーケットではスリランカの日常が息づいています。五感を刺激する活気に包まれながら、現地の食文化を肌で感じる特別なローカル体験をお楽しみください。",
        duration: "開催情報: 火曜日はリゾート近郊（車で約5分）、月曜日は別のローカルマーケット（車で約20分）",
        price: "ローカル体験",
        image: "/images/73237152-colombo-sri-lanka-december-6-2016-the-vegetable-stall-of-fose-market-in-pettah-with-wide-range.webp",
        alt: "ローカル野菜マーケット",
        badge: "Local",
    },
    {
        title: "Udawalawe National Park",
        subtitle: "豊かな自然と野生動物の楽園",
        summary: "中央高地の南に広がるウダワラウェ国立公園は、野生動物たちが自然のままの姿で暮らす楽園です。",
        details: "ウダワラウェ国立公園は、スリランカ中央高地の南側に位置し、野生のままの姿で暮らすエキゾチックな動物たちに出会える場所です。1972年に完成した広大な貯水湖を中心に、約30,000ヘクタールもの豊かな自然が守られています。ここではサル、バッファロー、イグアナ、ワニ、そして多種多様な鳥類など、驚くほど豊かな生態系を間近に観察することができます。中でも最大のハイライトは、野生のゾウたちです。雄大なゾウが水浴びを楽しんだり、群れで交流したりする力強い姿は、自然を愛するすべての人に深い感動を与えてくれます。",
        duration: "所要時間: 日帰りツアー（移動: 片道 約4時間）",
        price: "料金: 155ドル（約20,000 LKR）",
        image: "/images/Drive Ceylon/udawalawe/istockphoto-2155402343-612x612.webp",
        alt: "ウダワラウェ国立公園の野生動物",
        badge: "Wildlife",
    },
    {
        title: "Turtle Farm",
        subtitle: "子ガメを守り、広大な海へと送り出す",
        summary: "コスゴダのタートルファームは、絶滅危惧のウミガメを保護する歴史ある施設です。",
        details: "コスゴダにあるタートルファームは、スリランカで最も長い歴史を持つ保護施設のひとつです。1979年の設立以来、国の保護機関や環境団体、科学者たちと協力し、絶滅の危機に瀕しているウミガメを守る活動を続けています。ここでは、傷ついたウミガメの治療だけでなく、孵化したばかりの子ガメが外敵に襲われず無事に海へ帰れるよう、生後数日間の大切な時期を保護・支援しています。訪問者の皆様にいただく入場料は、これらの保護活動の貴重な資金源となります。実際に小さな子ガメに触れ、命の尊さを感じる心温まるひとときをお過ごしください。",
        duration: "アクセス: コスゴダまで車で約30分",
        price: "料金: 23ドル（約3,000 LKR）",
        image: "/images/Drive Ceylon/turtle/istockphoto-1170317746-612x612.webp",
        alt: "タートルファームのウミガメ",
        badge: "Conservation",
    },
    {
        title: "Sigiriya",
        subtitle: "王の物語が刻まれた天空の要塞",
        summary: "スリランカが世界に誇る文化遺産シギリヤは、世界第八の不思議とも称される壮大な遺跡です。",
        details: "スリランカが世界に誇る文化遺産シギリヤは、地元の人々から『世界第八の不思議』と称えられる壮大な遺跡です。ジャングルの緑の中から突如として現れる高さ200メートルの巨大な岩山『ライオンロック』の頂上には、かつてひとりの王が築いた幻の宮殿が眠っています。西暦473年、複雑な王位継承争いの末に父を殺害したカッサパ王が、追っ手を逃れ、自らの権威を象徴するためにこの岩山の上に王宮を築きました。岩壁の中腹に描かれた、色彩豊かな女性たちのフレスコ画『シギリヤ・レディ』は、当時の高度な芸術文化を今に伝えています。険しい階段を登りきった山頂からは、地平線まで続くジャングルの大パノラマが広がります。",
        duration: "所要時間: 片道 約5時間（ダンブッラ観光との組み合わせが可能）",
        price: "料金: 194ドル（約25,000 LKR）",
        image: "/images/tours/Sigiriya-Sri-Lanka-5-2.jpg.webp",
        alt: "シギリヤロック",
        badge: "Heritage",
    },
    {
        title: "Richmond Castle",
        subtitle: "失われた時代の記憶を留める壮麗な邸宅",
        summary: "20世紀初頭に築かれた、スリランカで最も壮麗な建築のひとつです。",
        details: "カルタラ近郊に位置するリッチモンド・キャッスルは、20世紀初頭に築かれた、スリランカで最も壮麗な建築のひとつです。かつて裕福なムダリ（植民地時代の高官）によって建てられたこの2階建ての邸宅は、インドの『マハラジャ宮殿』の様式を取り入れた優美なデザインが特徴です。34の窓と99の扉を持つこの壮大な建物は、過ぎ去った華やかな時代の記憶を今に伝えています。館内ツアーでは、オーナーの波乱に満ちた人生や当時の興味深いエピソードに触れることができます。現在は孤児たちのための教育施設としても活用されており、その気高い精神が受け継がれています。",
        duration: "アクセス: リゾートより車で約25分",
        price: "料金: 20ドル（約2,500 LKR）",
        image: "/images/richmond-castle-at-palatota.webp",
        alt: "リッチモンド・キャッスル",
        badge: "Culture",
    },
    {
        title: "Moonstone Mine",
        subtitle: "世界で唯一、神秘の石が生まれる場所へ",
        summary: "ミーティヤゴダは、世界で唯一ムーンストーンが採掘される希少な鉱山です。",
        details: "ミーティヤゴダは、世界で唯一ムーンストーンが採掘される非常に希少な鉱山として知られています。ここでは、伝統技術の粋を間近で見学することができます。深い坑道での採掘作業から、原石が熟練の職人によって美しいジュエリーへと磨き上げられるまでの全工程を体験いただけます。職人たちがそれぞれの工程を丁寧に解説してくれるほか、自分へのご褒美や大切な方へのお土産として、産地ならではのムーンストーンを購入することも可能です。",
        duration: "アクセス: 車で約1時間",
        price: "料金: 46ドル（約6,000 LKR）",
        image: "/images/mondsteinmine.webp",
        alt: "ムーンストーン鉱山",
        badge: "Craft",
    },
    {
        title: "Matugama",
        subtitle: "シンハラ農業と素朴なローカルライフ体験",
        summary: "稲作地帯やプランテーション、滝に立ち寄る穏やかなローカルツアーです。",
        details: "このツアーでは、見渡す限りの稲作地帯、ココナッツ、ゴム、そして紅茶のプランテーションといったスリランカの豊かな農業の風景、また道中では、心洗われるような美しい滝へも立ち寄ります。マトゥガマは内陸部に位置する、リゾートから最も近い主要都市のひとつです。観光地化されていないこの地では、スリランカの多様な自然と、そこで暮らす人々の温かな日常を肌で感じることができるでしょう。素朴でありながら豊かな、スリランカの『真の姿』に出会う心穏やかなひとときをお楽しみください。",
        duration: "アクセス: リゾートより車で約30分",
        price: "料金: 38ドル（約5,000 LKR）",
        image: "/images/images.webp",
        alt: "マトゥガマの農業風景",
        badge: "Local",
    },
    {
        title: "Madu River",
        subtitle: "朝焼けのボートトリップで、マングローブの森と聖なる島へ",
        summary: "早朝の柔らかな光の中、マングローブのトンネルと島々を巡るクルーズです。",
        details: "早朝の柔らかな光の中、ボートでマドゥ川へと漕ぎ出します。ガイドによる動植物の解説を聞きながら、マングローブのトンネルを抜け、湖に浮かぶ島々を巡ります。湖上の『コトゥドゥワ寺院』を訪れ、続くシナモン島では新鮮なシナモンティーを楽しみながら、伝統的な製法を学びます。運が良ければ、マングローブの中に潜むサルやカワセミ、オオトカゲなどの野生動物に出会えることもあります。",
        duration: "アクセス: バラピティヤまで車で45分",
        price: "料金: 62 USD (約8,000 LKR)",
        image: "/images/Madu-River-Safari-03.webp",
        alt: "マドゥ川のボートツアー",
        badge: "Nature",
    },
    {
        title: "Lunuganga",
        subtitle: "芸術家たちが愛した楽園",
        summary: "建築家ジェフリー・バワが長い歳月をかけて創り上げた熱帯の楽園です。",
        details: "スリランカが生んだ世界的建築家、ジェフリー・バワ。彼は40年以上の歳月をかけて、打ち捨てられたゴム園を『熱帯の楽園』へと作り変えました。40人の庭師と12人のスタッフの手によって守られてきたその景観は、デドゥワ湖とベントタ川を一望する、息を呑むほど美しいパノラマを生み出しています。自然の驚異と、細部まで愛を込めて設計された庭園は、訪れる皆さまを静かな感動へと誘います。",
        duration: "移動時間: リゾートから車で約30分",
        price: "料金: 21ドル（約2,700 LKR）",
        image: "/images/lunuganga_01.webp",
        alt: "ルヌガンガの庭園",
        badge: "Design",
    },
    {
        title: "Lighthouse Island",
        subtitle: "青い海に映える白い灯台",
        summary: "ベルワラの小さな島へボートで渡る、潮風が心地よいエクスカーションです。",
        details: "かつて小さな漁村だったベルワラは、今ではきめ細かな砂浜とクリスタルクリアな海、そしてヤシの木に囲まれた『真っ白な灯台』がある場所として、スリランカ全土で知られています。ボートで島へ渡れば、そこには日常を忘れさせるような美しい景色が広がっています。心地よい潮風を感じながら、歴史ある灯台の麓でゆったりとした時間を過ごすエクスカーション。どこまでも続く透明な海と空の青さは、皆さまの心に深い安らぎを届けてくれるでしょう。",
        duration: "移動時間: ボートで約20分",
        price: "料金: 38ドル（約5,000 LKR）",
        image: "/images/images (1).webp",
        alt: "ライトハウスアイランド",
        badge: "Sea",
    },
    {
        title: "Kataragama",
        subtitle: "聖なる祈りが交差する場所",
        summary: "南部の神聖な巡礼地で、多様な信仰が静かに交わる文化体験です。",
        details: "スリランカ南部で最も神聖な巡礼地、カタラガマ。その名は、この地で祀られる神に由来しています。ここでは、仏教徒、ヒンドゥー教徒、イスラム教徒、そして先住民のウェッダという異なる背景を持つ人々が、互いを尊重しながら同じ聖地で祈りを捧げていることです。色鮮やかな供物や儀式の響き、そして祈りに包まれた空気の中に身を置き、人々の純粋な信仰心と、長い歴史が紡いできた静かな活気に触れることは、深い精神的な安らぎを感じる体験となるでしょう。",
        duration: "移動時間: 車で約4時間（ヤーラ国立公園への旅行との組み合わせに最適です）",
        price: "料金: 195ドル（約25,000 LKR）",
        image: "/images/images (2).webp",
        alt: "カタラガマの巡礼風景",
        badge: "Spiritual",
    },
    {
        title: "Kandy",
        subtitle: "山間に息づく聖なる古都",
        summary: "仏歯寺、山並み、湖、植物園が織りなすスリランカ中央部の文化都市です。",
        details: "スリランカ中央部の山々に抱かれた大都市、キャンディ。この街の象徴といえば、4世紀から伝わる仏歯が納められている『仏歯寺（ダラダー・マーリガーワ寺院）』です。また、1990年代にバヒラワカンダ山の山頂に建立された巨大な大仏像は、街のいたるところからその神聖な姿を望むことができます。穏やかな『キャンディ湖』や広大な植物園、そして豊かな自然保護区など、この街には心を揺さぶる美しい風景が溢れています。",
        duration: "移動時間: 車で約4時間（1泊2日以上の行程をおすすめします）",
        price: "料金: 155ドル（約20,000 LKR）",
        image: "/images/Drive Ceylon/kandy/pexels-freestockpro-322437.webp",
        alt: "キャンディの寺院風景",
        badge: "Heritage",
    },
    {
        title: "Kalutara",
        subtitle: "白亜の巨大仏塔と、悟りの菩提樹が語る精神性",
        summary: "ガンガティラカ・ヴィハーラ寺院を訪ねる、心静かな文化ツアーです。",
        details: "壮大なガンガティラカ・ヴィハーラ寺院を訪ねる旅。この寺院の中心には、スリランカで唯一、内部に入って参拝できる貴重なダーゴバ（仏塔）が鎮座しています。遠くからでも目を引く真っ白な円形ドームは、現代仏教建築の象徴。歴史的な背景以上に、熱心な仏教徒たちが集う聖なる巡礼地として深く愛されています。また、敷地内には2,000年の歴史を持つとされる聖なる菩提樹があり、その根元で仏陀が悟りを開いたという言い伝えが今も大切に守られています。",
        duration: "移動時間: 車で約20分",
        price: "料金: 20ドル（約2,500 LKR）",
        image: "/images/images (3).webp",
        alt: "カルタラの寺院",
        badge: "Temple",
    },
    {
        title: "Galle",
        subtitle: "ヨーロッパの薫り漂う世界遺産",
        summary: "1663年にオランダ人によって築かれたゴール要塞は、ユネスコ世界遺産にも登録されています。",
        details: "1663年にオランダ人によって築かれたゴール要塞は、ユネスコ世界遺産にも登録されています。南アジアで最も保存状態の良い欧州式の要塞であり、ヨーロッパとアジアの建築様式が見事に融合した姿を今に伝えています。街のシンボルであるイエズス会創設の『聖マリア大聖堂』は必見です。ここからは、青い海に映える白亜の灯台や、歴史ある古い港の素晴らしい眺望を心ゆくまで楽しめます。石畳の小道を歩きながら、異国情緒あふれる優雅なひとときをお過ごしください。",
        duration: "移動時間: 車で約1時間",
        price: "料金: 73ドル（約9,500 LKR）",
        image: "/images/tours/Why-Galle-Fort-Is-a-Must-Visit-Day-Trip-from-Unawatuna-1050x700-1.webp",
        alt: "ゴール要塞の街並み",
        badge: "Heritage",
    },
    {
        title: "Fish Market",
        subtitle: "ベルワラの活気ある日常に触れる",
        summary: "ベルワラの朝に開かれる魚市場で、島の暮らしと豊かな生命力を感じる体験です。",
        details: "ベルワラの朝。海岸では地元の魚市場が開かれ、市場の屋台には、サメやエイ、レッドスナッパー（フエダイ）、マグロ、そして新鮮な甲殻類など、海から届いたばかりの魚介が所狭しと並びます。活気あふれる朝の空気の中で、スリランカの人々の暮らし、また島の豊かな生命力を感じてみてください。",
        duration: "移動時間: 車で約15分（毎日早朝に開催されます）",
        price: "ローカル体験",
        image: "/images/fischmarkt_01.webp",
        alt: "ベルワラの魚市場",
        badge: "Local",
    },
    {
        title: "Dambulla",
        subtitle: "黄金の寺院が守る聖なる石窟",
        summary: "シギリヤの近くにある、石窟寺院と世界遺産の黄金寺院で知られる街です。",
        details: "人気の観光地シギリヤのほど近くに位置するダンブッラは、数多くの見どころにあふれた街です。国内最大級の寺院群には、約80の石窟と合計153体もの仏像が安置されており、その圧倒的な存在感に目を奪われることでしょう。また、南アジア最大級のローズクォーツ（紅水晶）の産地や、アイアンウッドの森ナマル・ウヤナでも知られています。1991年に世界遺産に登録された色彩豊かな黄金寺院は、芸術や文化を愛する皆さまにとって、スリランカの旅のハイライトとなるはずです。",
        duration: "移動時間: 車で約5時間（1泊2日以上の行程をおすすめします）",
        price: "料金: 195ドル（約25,000 LKR）",
        image: "/images/dambulla.webp",
        alt: "ダンブッラの寺院",
        badge: "Heritage",
    },
    {
        title: "Brief Garden",
        subtitle: "緑の迷宮へようこそ",
        summary: "彫刻家ベヴィス・バワの旧邸宅で、自然と芸術が調和する隠れた名所です。",
        details: "彫刻家ベヴィス・バワ（ジェフリー・バワの兄）の旧邸宅であるブリーフ・ガーデンは、2006年から自然や芸術を愛する人々にその門戸を開いています。美しく手入れされた庭園と邸宅は、今なお観光地化されすぎていない、知る人ぞ知る隠れ家のような場所です。一歩足を踏み入れれば、そこは熱帯植物が茂り、エキゾチックな鳥たちが集う、曲がりくねった小道の迷宮。静寂に包まれたこの場所は、日常を忘れ、静かに瞑想するように散策できる空間です。バワ兄弟が愛した、スリランカの芸術的な感性に浸るひとときをお楽しみください。",
        duration: "所要時間: 約5分（車移動）",
        price: "料金: 20ドル（約2,500ルピー）",
        image: "/images/brief_garden_01.webp",
        alt: "ブリーフ・ガーデンの庭園",
        badge: "Garden",
    },
    {
        title: "Ambalangoda",
        subtitle: "伝統的な仮面文化と、アジア最大級の寝仏に出会う街",
        summary: "カラフルな寝仏と、スリランカの仮面文化が息づく活気ある街です。",
        details: "全長50mにも及ぶ、色彩豊かなアジア最大級の横たわる仏像（寝仏）が安置されています。ショッピングも楽しめる活気ある街で、地元の人々や観光客を惹きつけてやみません。また、この街はスリランカ伝統の『仮面』でも世界的に知られています。民俗芸能や治癒の儀式に使われるこれらの仮面は、地元の博物館で見学することができ、スリランカの奥深い精神文化に触れることができます。",
        duration: "移動時間: 車で約1時間",
        price: "料金: 43ドル（約5,500 LKR）",
        image: "/images/ambalangoda.webp",
        alt: "アンバランゴダの寝仏",
        badge: "Culture",
    },
    {
        title: "Aluthgama",
        subtitle: "仏陀の慈悲に触れる街",
        summary: "聖なる山の麓に位置し、街を見守る大仏像と穏やかな空気が魅力です。",
        details: "小さな街アルトゥガマに足を踏み入れると、そこには仏陀の穏やかなエネルギーが満ちているのを感じるでしょう。聖なる丘に立つ『カンデ・ヴィハーラ寺院』に近いだけでなく、街を見守るようにそびえ立つスリランカ最大級の座仏像が、この地を特別なものにしています。まだ観光地化されすぎていない素朴な雰囲気が残る一方で、ショッピングを楽しめるスポットも充実しています。静かな祈りと活気ある日常が共存する、スリランカらしい魅力に溢れた街です。",
        duration: "移動時間: 車で約20分",
        price: "料金: 20ドル（約2,500 LKR）",
        image: "/images/image015-1040x598.webp",
        alt: "アルトゥガマの仏像",
        badge: "Temple",
    },
];
const TourLocations = () => {
    const [activeTour, setActiveTour] = useState(null);
    useEffect(() => {
        if (!activeTour) {
            document.body.style.overflow = "auto";
            return;
        }
        document.body.style.overflow = "hidden";
        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                setActiveTour(null);
            }
        };
        window.addEventListener("keydown", onKeyDown);
        return () => {
            window.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = "auto";
        };
    }, [activeTour]);
    return (_jsxs("section", { className: "relative overflow-hidden bg-[linear-gradient(180deg,#fffaf2_0%,#ffffff_45%,#f8f5f1_100%)] py-16 sm:py-20 lg:py-28", children: [_jsx("div", { className: "absolute -left-20 top-10 h-72 w-72 rounded-full bg-amber-200/25 blur-3xl" }), _jsx("div", { className: "absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-emerald-200/20 blur-3xl" }), _jsxs("div", { className: "container relative mx-auto px-4 sm:px-6 lg:px-8", children: [_jsxs("div", { className: "mx-auto max-w-3xl text-center", children: [_jsx("span", { className: "inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-4 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-amber-800 shadow-sm backdrop-blur md:text-sm", children: "\u30C4\u30A2\u30FC\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3" }), _jsx("h2", { className: "mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl", children: "\u65C5\u5148\u3067\u51FA\u4F1A\u3046\u3001\u81EA\u7136\u3068\u6B74\u53F2\u306E\u7269\u8A9E" }), _jsx("p", { className: "mt-4 font-mulish text-base leading-relaxed text-gray-700 sm:text-lg", children: "\u6C17\u306B\u306A\u308B\u30AB\u30FC\u30C9\u306E\u300C\u8A73\u3057\u304F\u898B\u308B\u300D\u3092\u62BC\u3059\u3068\u3001\u8A73\u7D30\u304C\u30E2\u30FC\u30C0\u30EB\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u958B\u304D\u307E\u3059\u3002" })] }), _jsx("div", { className: "mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4", children: tourCards.map((tour) => (_jsxs("article", { className: "group overflow-hidden rounded-[22px] bg-white shadow-[0_20px_55px_rgba(15,23,42,0.1)] transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_26px_65px_rgba(15,23,42,0.14)]", children: [_jsxs("div", { className: "relative aspect-[4/3] w-full overflow-hidden", children: [_jsx(Image, { src: tour.image, alt: tour.alt, fill: true, sizes: "(max-width: 640px) 100vw, (max-width: 1280px) 50vw, 25vw", className: "object-contain object-center", quality: 90 }), _jsx("div", { className: "absolute inset-0 bg-gradient-to-t from-black/70 via-black/18 to-transparent" }), _jsxs("div", { className: "absolute inset-x-0 bottom-0 p-4 text-white", children: [_jsx("p", { className: "font-serif text-xl font-semibold leading-tight", children: tour.title }), _jsx("p", { className: "mt-1.5 text-sm leading-5 text-white/88", children: tour.subtitle })] })] }), _jsxs("div", { className: "space-y-3 p-4 sm:p-5", children: [_jsx("p", { className: "text-sm leading-6 text-gray-700", children: tour.summary }), _jsx("div", { className: "flex flex-wrap gap-3", children: _jsx("button", { type: "button", onClick: () => setActiveTour(tour), className: "inline-flex items-center justify-center rounded-full bg-[#F28600] px-4 py-2 text-sm font-semibold text-[#1f4d3c] shadow-lg shadow-yellow-200/70 transition hover:bg-[#e7b90d]", children: "\u8A73\u3057\u304F\u898B\u308B" }) })] })] }, `${tour.title}-${tour.badge}`))) })] }), activeTour ? (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm", role: "dialog", "aria-modal": "true", "aria-label": activeTour.title, onClick: () => setActiveTour(null), children: _jsx("div", { className: "max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-[32px] border border-white/70 bg-white shadow-[0_30px_100px_rgba(15,23,42,0.35)]", onClick: (event) => event.stopPropagation(), children: _jsxs("div", { className: "grid grid-cols-1 lg:grid-cols-2", children: [_jsxs("div", { className: "relative min-h-[280px] lg:min-h-full", children: [_jsx(Image, { src: activeTour.image, alt: activeTour.alt, fill: true, sizes: "(max-width: 1024px) 100vw, 50vw", className: "object-contain object-center", quality: 90 }), _jsx("div", { className: "absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" })] }), _jsxs("div", { className: "max-h-[90vh] overflow-y-auto p-6 sm:p-8 lg:p-10", children: [_jsxs("div", { className: "flex items-start justify-between gap-4", children: [_jsxs("div", { children: [_jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.22em] text-amber-800", children: activeTour.badge }), _jsx("h3", { className: "mt-3 font-serif text-3xl font-semibold leading-tight text-[#1f4d3c] sm:text-4xl", children: activeTour.title }), _jsx("p", { className: "mt-3 font-serif text-xl font-medium text-[#24422f]", children: activeTour.subtitle })] }), _jsx("button", { type: "button", onClick: () => setActiveTour(null), className: "flex h-10 w-10 items-center justify-center rounded-full border border-amber-200 text-lg font-semibold text-[#1f4d3c] transition hover:border-[#F28600] hover:text-[#d67000]", "aria-label": "Close details", children: "\u00D7" })] }), _jsxs("div", { className: "mt-6 space-y-4 text-[15px] leading-8 text-gray-700 sm:text-base", children: [_jsx("p", { children: activeTour.details }), _jsx("p", { className: "font-semibold text-[#1f4d3c]", children: activeTour.duration }), _jsx("p", { className: "font-semibold text-[#1f4d3c]", children: activeTour.price })] }), _jsx("div", { className: "mt-8 flex flex-wrap gap-3", children: _jsx("button", { type: "button", onClick: () => setActiveTour(null), className: "inline-flex items-center justify-center rounded-full bg-[#F3C623] px-6 py-3 text-sm font-semibold text-[#1f4d3c] shadow-lg shadow-yellow-200/70 transition hover:bg-[#e7b90d]", children: "\u9589\u3058\u308B" }) })] })] }) }) })) : null] }));
};
export default TourLocations;
